import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { TSpace } from '../../types/space.type';

export const DeleteSpaceAdminValidationSchema = z.object({
  spaceId: z.string({ message: 'Space ID is required' }).min(1),
});
export type TDeleteSpaceAdminValidation = z.infer<typeof DeleteSpaceAdminValidationSchema>;
export type TDeleteSpaceAdminPayload = TDeleteSpaceAdminValidation;
export type TDeleteSpaceAdminResponse = ApiResponse<TSpace>;

export const deleteSpaceAdmin = (payload: TDeleteSpaceAdminPayload): Promise<TDeleteSpaceAdminResponse> => {
  const url = `/space/admin/${payload.spaceId}`;

  return axiosInstance.delete(url);
};

/**
 * Use Delete Space Admin React-Query Hook
 */
type UseDeleteSpaceAdminMutationOptions = {
  mutationConfig?: TypedMutationConfig<typeof deleteSpaceAdmin, AxiosErrorCustom>;
};

export const useDeleteSpaceAdminMutation = ({ mutationConfig }: UseDeleteSpaceAdminMutationOptions) => {
  const { ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: deleteSpaceAdmin,
    ...restConfig,
  });
};
